import firebase from "firebase/app";
import FirestoreService from "./FirestoreService";

export default class VideoService {

    static listenToVideo(uid, callback) {
        FirestoreService.firestoreDB()
            .collection("trainingvideos")
            .doc(uid)
            .onSnapshot(
            doc => {
                callback(null, doc.data());
                //console.log("Current data: ", doc && doc.data());
            },
            function (err) {
                callback(err);
            }
            );
    }

    static getVideo(id) {
        return FirestoreService.firestoreDB().collection('trainingvideos').doc(id).get();
    }
    

    static getAllVideos(callback) {
        const collectionRef = FirestoreService.firestoreDB().collection('trainingvideos');
        const query = collectionRef.orderBy('createddatetime', 'desc').limit(50);
        this.getDocumentsInQuery(query, callback, collectionRef);
    }    

    static getDocumentsInQuery(query, callback, collectionRef) {
        query.onSnapshot(snapshot => {
            if (!snapshot.size) return;

            callback(snapshot, collectionRef);

        });
    }

    static updateVideo(video) {
        if (!video || !video.id) {
            throw new Error("Video Id is required for the update");            
        }          

        const videoRef = FirestoreService.firestoreDB()
            .collection("trainingvideos")
            .doc(video.id);

        var videoData = {
            name: video.name,
            url: video.url,            
            clusters: FirestoreService.ArrayToObject(video.clusters),            
            expirydate: video.expirydate,
            releasedate: video.releasedate,
            enabled: video.enabled,
            manageronly: video.manageronly
        };        

        videoRef.update(videoData).catch(function (error) {
            console.error("Error updating video: ", error);
            alert("Cannot update a video\r\n" + error.message);
        });
    }


    static deleteVideo(video) {
        if (!video || !video.id) {
            throw new Error("Video Id is required for the delete action");
        }
        FirestoreService.deleteDocument('trainingvideos', video.id);
    }

    static createVideo(video, callback) {
        if (!video) {
            return;
        }

        const timestamp = FirestoreService.timestamp();
        const videoData = {            
            name: video.name,
            url: video.url,
            clusters: FirestoreService.ArrayToObject(video.clusters),
            createduserid: firebase.auth().currentUser.uid,            
            createddatetime: timestamp,            
            expirydate: video.expirydate,
            releasedate: video.releasedate,
            enabled: video.enabled,
            manageronly: video.manageronly
        };

        FirestoreService.firestoreDB()
            .collection("trainingvideos")
            .add(videoData)
            .then(docRef => {
                console.log("Document written with ID: ", docRef.id);
                videoData.id = docRef.id;
                callback(videoData);
            })
            .catch(function (error) {
                console.error("Error adding document: ", error);
                alert("Cannot create a video\r\n" + error.message);
            });
    }    
}



// WEBPACK FOOTER //
// ./src/service/VideoService.js